var map = {
  "./VRARelation.js": [
    "73840",
    "4496"
  ],
  "./VRASource.js": [
    "80766",
    "2755"
  ],
  "./VRALocation.js": [
    "34540",
    "2093"
  ],
  "./VRAAgent.js": [
    "53426",
    "9791"
  ],
  "./VRAStateEdition.js": [
    "14778",
    "5015"
  ],
  "./VRADate.js": [
    "66659",
    "2432"
  ],
  "./VRAInscription.js": [
    "21153",
    "1386"
  ],
  "./VRAMeasurements.js": [
    "63798",
    "1755"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 34222;
module.exports = __rspack_async_context;
